import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/tmp/build_2570dc51/node_modules/@mui/icons-material/OpenInNew.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/tmp/build_2570dc51/node_modules/@mui/icons-material/Public.js");
;
import(/* webpackMode: "eager" */ "/tmp/build_2570dc51/node_modules/@mui/material/Box/index.js");
;
import(/* webpackMode: "eager" */ "/tmp/build_2570dc51/node_modules/@mui/material/Button/index.js");
;
import(/* webpackMode: "eager" */ "/tmp/build_2570dc51/node_modules/@mui/material/CircularProgress/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build_2570dc51/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/tmp/build_2570dc51/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/build_2570dc51/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/build_2570dc51/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/build_2570dc51/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build_2570dc51/src/app/[slug]/clientSide.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build_2570dc51/src/app/[slug]/FooterTags.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build_2570dc51/src/app/[slug]/RelatedPosts.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/build_2570dc51/src/app/[slug]/TestPage.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build_2570dc51/src/components/display/Publisher/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build_2570dc51/src/components/display/PublisherBio/index.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/build_2570dc51/src/components/display/Title/Title.module.scss");
;
import(/* webpackMode: "eager" */ "/tmp/build_2570dc51/src/app/[slug]/TranslateArticle.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build_2570dc51/src/components/inputs/RateTranslation/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/build_2570dc51/src/components/inputs/StatsSection/index.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/build_2570dc51/src/components/inputs/TextEditor/index.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/build_2570dc51/src/components/loaders/FastCircleLoader.module.scss");
;
import(/* webpackMode: "eager" */ "/tmp/build_2570dc51/src/modules/imageService/placeholder.svg");
